var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"dense":"","items":_vm.contractStatusValues,"return-object":"","single-line":"","disabled":_vm.role !== 'admin' || _vm.role !== 'coordinator' ? false : true},model:{value:(_vm.selectedOption),callback:function ($$v) {_vm.selectedOption=$$v},expression:"selectedOption"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }